import React from 'react';

const testIds = {
    COLON_ICON: 'COLON_ICON'
};

const ColonIcon = (props: any) => (
    <svg
        data-test-id={testIds.COLON_ICON}
        {...props}
        width="3"
        height="10"
        viewBox="0 0 3 10"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M1.49744 6.456C1.8921 6.456 2.20677 6.56267 2.44144 6.776C2.6761 6.97867 2.79344 7.26133 2.79344 7.624V8.008C2.79344 8.37067 2.6761 8.65867 2.44144 8.872C2.20677 9.07467 1.8921 9.176 1.49744 9.176C1.10277 9.176 0.788104 9.07467 0.553438 8.872C0.318771 8.65867 0.201438 8.37067 0.201438 8.008V7.624C0.201438 7.26133 0.318771 6.97867 0.553438 6.776C0.788104 6.56267 1.10277 6.456 1.49744 6.456ZM1.49744 0.471999C1.8921 0.471999 2.20677 0.578666 2.44144 0.792C2.6761 0.994666 2.79344 1.27733 2.79344 1.64V2.024C2.79344 2.38667 2.6761 2.67467 2.44144 2.888C2.20677 3.09067 1.8921 3.192 1.49744 3.192C1.10277 3.192 0.788104 3.09067 0.553438 2.888C0.318771 2.67467 0.201438 2.38667 0.201438 2.024V1.64C0.201438 1.27733 0.318771 0.994666 0.553438 0.792C0.788104 0.578666 1.10277 0.471999 1.49744 0.471999Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {ColonIcon};
